export const PurchaseOpportunityStatusIds: { [key: string]: number } = {
  PENDING: 1,
  SELECTED: 2,
  NOT_SELECTED: 3,
  CHARGED: 4,
  REFUNDED: 5,
};
